import React from "react";
import { useState } from "react";

//CSS
import "./printPopup.css";

//Components
import InputField from "./inputField";
import Button from "./button";

import { useTranslation } from "react-i18next";

export default function PrintPopup({ title, printers, onPrint, onClose }) {
  const [selectedPrinter, setSelectedPrinter] = useState(
    printers[0]?.name || ""
  );
  const [isTestMode, setIsTestMode] = useState(false);
  const [isPrinting, setIsPrinting] = useState(false);

  const { t } = useTranslation("printer");

  const toggleClick = () => {
    const newMode = !isTestMode;
    setIsTestMode(newMode);
  };

  const handlePrintClick = async () => {
    setIsPrinting(true);
    await onPrint({ selectedPrinter, isTestMode });
    setIsPrinting(false);
    onClose();
  };

  return (
    <div className="print-overlay">
      <div className="print-confirmation-container">
        <h3>{t("Print") + " " + t(title)}</h3>

        {printers.length > 0 && (
          <InputField
            label="Select Printer:"
            value={selectedPrinter}
            onChange={(val) => setSelectedPrinter(val)}
            type="dropdown"
            options={printers.map((printer) => ({
              value: printer.name,
              label: printer.name,
            }))}
            className="mb-3"
          />
        )}

        <div className="test-mode-toggle mb-3" onClick={() => toggleClick()}>
          <div className={"checkbox " + (isTestMode ? "checked" : "")} />
          <label>{t("Note preview mode (Not for printing!)")}</label>
        </div>

        <div className="button-group">
          <Button
            btnStyle="btn-primary"
            btnSize="btn-small"
            onClick={handlePrintClick}
            className="mr-2"
            disabled={isPrinting}
            icon="apply"
          >
            {t(isPrinting ? "Printing..." : "Print")}
          </Button>
          <Button btnStyle="btn-negative" btnSize="btn-small" onClick={onClose}>
            {t("Cancel", { ns: "common" })}
          </Button>
        </div>
      </div>
    </div>
  );
}
